import React, { Component, Suspense } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import './scss/style.scss'
import moment from 'moment'
import { jwtDecode } from 'jwt-decode'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Logout = React.lazy(() => import('./views/pages/login/Logout'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {

  isLogged() {
    try {

      if (localStorage.getItem("dataInicio") == null) {
        localStorage.setItem("dataInicio", moment(new Date()).add(1, 'day').format('YYYY-MM-DD'));
        localStorage.setItem("dataFim", moment(new Date()).add(16, 'day').format('YYYY-MM-DD'));
      }

      const usuarioJson = localStorage.getItem('usuario');
      const usuario = JSON.parse(usuarioJson);

      const decoded = jwtDecode(usuario?.token);
      console.log(decoded); 

      localStorage.setItem("userCPF", decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"])
      localStorage.setItem("roles", decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"])

      return usuario.token && usuario.token !== ''
    } catch (e) {
      console.log(e);
    }
    return false;
  }

  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route
              exact
              path="/"
              name="Guard"
              element={<ProtectedRoute isAllowed={this.isLogged()} />}
            >
              <Route path="/" name="Default" element={<DefaultLayout />} />
            </Route>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/logout" name="Logout Page" element={<Logout />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Default" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

export default App
